// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import _ from 'lodash';

/**
 * See doc here: https://github.com/clauderic/react-sortable-hoc
 *
 * The renderer must return a component with a class 'row'.
 * Each 'case' of the component have to use a col-* class.
 * The container have to use the class 'row' and can use the class 'table_container'
 */
export default class SortableList extends Component {

  static DragHandle = SortableHandle(() => {
    return (
      <i className="fa fa-bars sortable_list__drag_handle pointer" />
    );
  });

  static SortableHandle = SortableHandle;

  static defaultProps = {
    renderer: null,

    displayDragIcon: false
  };

  static propTypes = {
    className: PropTypes.object,

    /**
    * A function that will render each row.
    * @type func
    * @param item
    */
    renderer: PropTypes.func,

    items: PropTypes.array.isRequired,

    /**
     * Should we display a drag icon ?
     * @type {[type]}
     */
    displayDragIcon: PropTypes.bool,

    /**
     * The function called
     * @type func
     *
     * @param array of items
     */
    onChange: PropTypes.func.isRequired
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    let {items} = this.props;

    this.props.onChange(arrayMove(items, oldIndex, newIndex));
  };

  render() {
    let {items} = this.props;

    const SortableItem = SortableElement(({value}) => {
      //
      // Render view
      //

      const { renderer, displayDragIcon } = this.props;
      let view = (null);

      if (!_.isNull(renderer)) {
        view = (
          <div className="custom_renderer_sortable_item">
            {renderer(value)}
          </div>
        );
      } else {
        // default rendering.
        view = (
          <div className="default_renderer_sortable_item">
            {value}
          </div>
        );
      }

      //
      // Drag icon
      //

      const DragHandle = SortableHandle(() => {
        return (
          <span className="drag_icon">
            <i className="fa fa-bars" />
          </span>
        );
      });

      //
      // Render
      //

      return (
        <div className="sortable_item">
          {displayDragIcon &&
            <DragHandle />
          }
          {view}
        </div>
      )
    });

    const SortableListContainer = SortableContainer(({items}) => {
      return (
        <div className="sortable_list__container">
          {items.map((value, index) =>
            <SortableItem
              key={`item-${index}`}
              index={index}
              value={value}
            />
          )}
        </div>
      );
    });

    return (
      <div className="sortable_list col-xs-12">
        <SortableListContainer
          items={items}
          onSortEnd={this.onSortEnd}
          useDragHandle={true}
        />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/SortableList.js